module.exports = __webpack_public_path__ + "static/img/bank.9ef260b.png";


//////////////////
// WEBPACK FOOTER
// ./static/bank.png
// module id = DEaw
// module chunks = 1